// This file is auto-generated by @hey-api/openapi-ts

import type {
  GetActivityResponse,
  GetAuthSessionResponse,
  GetCompaniesByIdActivityResponse,
  GetCompaniesByIdDocumentsResponse,
  GetCompaniesByIdHistoryResponse,
  GetCompaniesByIdProjectsResponse,
  GetCompaniesByIdResponse,
  GetCompaniesResponse,
  GetGroupsResponse,
  GetOrganizationsResponse,
  GetPermissionsAuditResponse,
  GetRolesByIdResponse,
  GetRolesResponse,
  GetUsersByIdPermissionsEffectiveResponse,
  GetUsersByIdResponse,
  GetUsersMeResponse,
  GetUsersResponse,
  PatchCompaniesByIdResponse,
  PatchGroupsByIdResponse,
  PatchRolesByIdResponse,
  PatchUsersByIdResponse,
  PatchUsersMeResponse,
  PostAuthLoginResponse,
  PostAuthRefreshResponse,
  PostCompaniesByIdDocumentsResponse,
  PostCompaniesResponse,
  PostGroupsResponse,
  PostOrganizationsActiveResponse,
  PostOrganizationsResponse,
  PostRolesResponse,
  PostUsersByIdPermissionsDenyResponse,
  PostUsersByIdPermissionsGrantResponse,
  PostUsersResponse,
} from './types.gen'

const loginResponseSchemaResponseTransformer = (data: any) => {
  if (data.user.lastLoginAt) {
    data.user.lastLoginAt = new Date(data.user.lastLoginAt)
  }
  data.user.createdAt = new Date(data.user.createdAt)
  data.user.updatedAt = new Date(data.user.updatedAt)
  return data
}

export const postAuthLoginResponseTransformer = async (
  data: any
): Promise<PostAuthLoginResponse> => {
  data = loginResponseSchemaResponseTransformer(data)
  return data
}

const refreshResponseSchemaResponseTransformer = (data: any) => {
  if (data.user.lastLoginAt) {
    data.user.lastLoginAt = new Date(data.user.lastLoginAt)
  }
  data.user.createdAt = new Date(data.user.createdAt)
  data.user.updatedAt = new Date(data.user.updatedAt)
  return data
}

export const postAuthRefreshResponseTransformer = async (
  data: any
): Promise<PostAuthRefreshResponse> => {
  data = refreshResponseSchemaResponseTransformer(data)
  return data
}

const authUserSchemaResponseTransformer = (data: any) => {
  if (data.lastLoginAt) {
    data.lastLoginAt = new Date(data.lastLoginAt)
  }
  data.createdAt = new Date(data.createdAt)
  data.updatedAt = new Date(data.updatedAt)
  return data
}

export const getAuthSessionResponseTransformer = async (
  data: any
): Promise<GetAuthSessionResponse> => {
  data = authUserSchemaResponseTransformer(data)
  return data
}

const frontendUserSchemaResponseTransformer = (data: any) => {
  if (data.lastLoginAt) {
    data.lastLoginAt = new Date(data.lastLoginAt)
  }
  data.createdAt = new Date(data.createdAt)
  data.updatedAt = new Date(data.updatedAt)
  return data
}

export const getUsersMeResponseTransformer = async (data: any): Promise<GetUsersMeResponse> => {
  data = frontendUserSchemaResponseTransformer(data)
  return data
}

export const patchUsersMeResponseTransformer = async (data: any): Promise<PatchUsersMeResponse> => {
  data = frontendUserSchemaResponseTransformer(data)
  return data
}

const paginatedUsersResponseSchemaResponseTransformer = (data: any) => {
  data.data = data.data.map((item: any) => {
    if (item.lastLoginAt) {
      item.lastLoginAt = new Date(item.lastLoginAt)
    }
    item.createdAt = new Date(item.createdAt)
    item.updatedAt = new Date(item.updatedAt)
    return item
  })
  return data
}

export const getUsersResponseTransformer = async (data: any): Promise<GetUsersResponse> => {
  data = paginatedUsersResponseSchemaResponseTransformer(data)
  return data
}

export const postUsersResponseTransformer = async (data: any): Promise<PostUsersResponse> => {
  data = frontendUserSchemaResponseTransformer(data)
  return data
}

export const getUsersByIdResponseTransformer = async (data: any): Promise<GetUsersByIdResponse> => {
  data = frontendUserSchemaResponseTransformer(data)
  return data
}

export const patchUsersByIdResponseTransformer = async (
  data: any
): Promise<PatchUsersByIdResponse> => {
  data = frontendUserSchemaResponseTransformer(data)
  return data
}

const effectivePermissionsSchemaResponseTransformer = (data: any) => {
  data.groups = data.groups.map((item: any) => {
    item.createdAt = new Date(item.createdAt)
    item.updatedAt = new Date(item.updatedAt)
    return item
  })
  return data
}

export const getUsersByIdPermissionsEffectiveResponseTransformer = async (
  data: any
): Promise<GetUsersByIdPermissionsEffectiveResponse> => {
  data = effectivePermissionsSchemaResponseTransformer(data)
  return data
}

const userPermissionGrantSchemaResponseTransformer = (data: any) => {
  data.grantedAt = new Date(data.grantedAt)
  if (data.expiresAt) {
    data.expiresAt = new Date(data.expiresAt)
  }
  return data
}

export const postUsersByIdPermissionsGrantResponseTransformer = async (
  data: any
): Promise<PostUsersByIdPermissionsGrantResponse> => {
  data = userPermissionGrantSchemaResponseTransformer(data)
  return data
}

export const postUsersByIdPermissionsDenyResponseTransformer = async (
  data: any
): Promise<PostUsersByIdPermissionsDenyResponse> => {
  data = userPermissionGrantSchemaResponseTransformer(data)
  return data
}

const companySchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt)
  data.updatedAt = new Date(data.updatedAt)
  return data
}

const companiesResponseSchemaResponseTransformer = (data: any) => {
  data.companies = data.companies.map((item: any) => companySchemaResponseTransformer(item))
  return data
}

export const getCompaniesResponseTransformer = async (data: any): Promise<GetCompaniesResponse> => {
  data = companiesResponseSchemaResponseTransformer(data)
  return data
}

export const postCompaniesResponseTransformer = async (
  data: any
): Promise<PostCompaniesResponse> => {
  data = companySchemaResponseTransformer(data)
  return data
}

export const getCompaniesByIdResponseTransformer = async (
  data: any
): Promise<GetCompaniesByIdResponse> => {
  data = companySchemaResponseTransformer(data)
  return data
}

export const patchCompaniesByIdResponseTransformer = async (
  data: any
): Promise<PatchCompaniesByIdResponse> => {
  data = companySchemaResponseTransformer(data)
  return data
}

const companyProjectSchemaResponseTransformer = (data: any) => {
  data.updated = new Date(data.updated)
  return data
}

const companyProjectListSchemaResponseTransformer = (data: any) => {
  data = data.map((item: any) => companyProjectSchemaResponseTransformer(item))
  return data
}

export const getCompaniesByIdProjectsResponseTransformer = async (
  data: any
): Promise<GetCompaniesByIdProjectsResponse> => {
  data = companyProjectListSchemaResponseTransformer(data)
  return data
}

const companyDocumentSchemaResponseTransformer = (data: any) => {
  data.date = new Date(data.date)
  return data
}

const companyDocumentListSchemaResponseTransformer = (data: any) => {
  data = data.map((item: any) => companyDocumentSchemaResponseTransformer(item))
  return data
}

export const getCompaniesByIdDocumentsResponseTransformer = async (
  data: any
): Promise<GetCompaniesByIdDocumentsResponse> => {
  data = companyDocumentListSchemaResponseTransformer(data)
  return data
}

export const postCompaniesByIdDocumentsResponseTransformer = async (
  data: any
): Promise<PostCompaniesByIdDocumentsResponse> => {
  data = companyDocumentSchemaResponseTransformer(data)
  return data
}

const changeHistoryEntrySchemaResponseTransformer = (data: any) => {
  data.date = new Date(data.date)
  return data
}

const changeHistoryListSchemaResponseTransformer = (data: any) => {
  data = data.map((item: any) => changeHistoryEntrySchemaResponseTransformer(item))
  return data
}

export const getCompaniesByIdHistoryResponseTransformer = async (
  data: any
): Promise<GetCompaniesByIdHistoryResponse> => {
  data = changeHistoryListSchemaResponseTransformer(data)
  return data
}

const activityLogEntrySchemaResponseTransformer = (data: any) => {
  data.time = new Date(data.time)
  return data
}

const activityLogListSchemaResponseTransformer = (data: any) => {
  data = data.map((item: any) => activityLogEntrySchemaResponseTransformer(item))
  return data
}

export const getCompaniesByIdActivityResponseTransformer = async (
  data: any
): Promise<GetCompaniesByIdActivityResponse> => {
  data = activityLogListSchemaResponseTransformer(data)
  return data
}

const organizationSummarySchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt)
  data.updatedAt = new Date(data.updatedAt)
  return data
}

const organizationListResponseSchemaResponseTransformer = (data: any) => {
  data.organizations = data.organizations.map((item: any) =>
    organizationSummarySchemaResponseTransformer(item)
  )
  return data
}

export const getOrganizationsResponseTransformer = async (
  data: any
): Promise<GetOrganizationsResponse> => {
  data = organizationListResponseSchemaResponseTransformer(data)
  return data
}

const organizationSchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt)
  data.updatedAt = new Date(data.updatedAt)
  return data
}

export const postOrganizationsResponseTransformer = async (
  data: any
): Promise<PostOrganizationsResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const postOrganizationsActiveResponseTransformer = async (
  data: any
): Promise<PostOrganizationsActiveResponse> => {
  data = frontendUserSchemaResponseTransformer(data)
  return data
}

const roleDefinitionSchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt)
  data.updatedAt = new Date(data.updatedAt)
  return data
}

const roleDefinitionListSchemaResponseTransformer = (data: any) => {
  data = data.map((item: any) => roleDefinitionSchemaResponseTransformer(item))
  return data
}

export const getRolesResponseTransformer = async (data: any): Promise<GetRolesResponse> => {
  data = roleDefinitionListSchemaResponseTransformer(data)
  return data
}

export const postRolesResponseTransformer = async (data: any): Promise<PostRolesResponse> => {
  data = roleDefinitionSchemaResponseTransformer(data)
  return data
}

const userGroupSchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt)
  data.updatedAt = new Date(data.updatedAt)
  return data
}

const userGroupListSchemaResponseTransformer = (data: any) => {
  data = data.map((item: any) => userGroupSchemaResponseTransformer(item))
  return data
}

export const getGroupsResponseTransformer = async (data: any): Promise<GetGroupsResponse> => {
  data = userGroupListSchemaResponseTransformer(data)
  return data
}

export const postGroupsResponseTransformer = async (data: any): Promise<PostGroupsResponse> => {
  data = userGroupSchemaResponseTransformer(data)
  return data
}

const permissionAuditResponseSchemaResponseTransformer = (data: any) => {
  data.data = data.data.map((item: any) => {
    item.timestamp = new Date(item.timestamp)
    return item
  })
  return data
}

export const getPermissionsAuditResponseTransformer = async (
  data: any
): Promise<GetPermissionsAuditResponse> => {
  data = permissionAuditResponseSchemaResponseTransformer(data)
  return data
}

export const getRolesByIdResponseTransformer = async (data: any): Promise<GetRolesByIdResponse> => {
  data = roleDefinitionSchemaResponseTransformer(data)
  return data
}

export const patchRolesByIdResponseTransformer = async (
  data: any
): Promise<PatchRolesByIdResponse> => {
  data = roleDefinitionSchemaResponseTransformer(data)
  return data
}

export const patchGroupsByIdResponseTransformer = async (
  data: any
): Promise<PatchGroupsByIdResponse> => {
  data = userGroupSchemaResponseTransformer(data)
  return data
}

const auditLogEntrySchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt)
  return data
}

const paginatedActivityResponseSchemaResponseTransformer = (data: any) => {
  data.data = data.data.map((item: any) => auditLogEntrySchemaResponseTransformer(item))
  return data
}

export const getActivityResponseTransformer = async (data: any): Promise<GetActivityResponse> => {
  data = paginatedActivityResponseSchemaResponseTransformer(data)
  return data
}
